import styled from "styled-components";

export const RowContainer = styled.div<{ solidBorder?: boolean }>`
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  background-color: ${({ theme }) => theme.white};
  padding: 16px;
  margin: 0px;
  border-bottom: ${(props) =>
    props.solidBorder
      ? `1px solid ${props.theme.backgroundGrey}`
      : `1px dashed ${props.theme.backgroundGrey}`};
  :last-child {
    border-bottom: none;
  }
`;

export const Name = styled.p`
  color: ${({ theme }) => theme.black};
  margin-left: 1.6rem;
  font-size: 1.2rem;
  font-weight: bold;
`;

export const BestIcon = styled.img`
  width: 3.2rem;
  height: 3.2rem;
  border-radius: 50%;
`;

export const BookmakerLogo = styled.picture`
  width: 3.2rem;
  height: 3.2rem;
  border-radius: 4px;
`;

export const BookmakerContainer = styled.div`
  display: flex;
  align-items: center;
`;

export const Description = styled.p`
  font-size: 1rem;
  margin: 0px;
`;
